<template>
  <div>
    <div class="col-md-12 mx-auto text-center">
      <h6 class="font-weight-bold">{{ title }}</h6>
      <p>{{ description }}</p>
    </div>
    <div :dir="$i18n.locale === 'fa' ? 'rtl' : 'ltr'">
      <flip-countdown
        :key="$i18n.locale"
        :deadline="gregorianValue"
        :labels="translatedLabels"
      ></flip-countdown>
    </div>
  </div>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";
import moment from "moment-jalaali";

export default {
  name: "countDown",
  components: { FlipCountdown },
  props: {
    value: {
      default: () => moment().format("YYYY-MM-DD HH:mm:ss"),
    },
    title: {
      default: "",
    },
    description: {
      default: "",
    },
  },
  computed: {
    translatedLabels() {
      return {
        days: this.$t("day"),
        hours: this.$t("hour"),
        minutes: this.$t("minute"),
        seconds: this.$t("second"),
      };
    },
    gregorianValue() {
      return this.convertToGregorian(this.value);
    },
  },
  methods: {
    normalizeNumerals(date) {
      if (!date) return date;
      const arabicNumerals = "٠١٢٣٤٥٦٧٨٩";
      const persianNumerals = "۰۱۲۳۴۵۶۷۸۹";
      const westernNumerals = "0123456789";
      return date
        .replace(
          /[٠١٢٣٤٥٦٧٨٩]/g,
          (match) => westernNumerals[arabicNumerals.indexOf(match)],
        )
        .replace(
          /[۰۱۲۳۴۵۶۷۸۹]/g,
          (match) => westernNumerals[persianNumerals.indexOf(match)],
        );
    },
    convertToGregorian(date) {
      if (!date) {
        return moment().format("YYYY-MM-DD HH:mm:ss");
      }
      const normalizedDate = this.normalizeNumerals(date);
      let parsedDate;
      if (moment(normalizedDate, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
        parsedDate = moment(normalizedDate, "YYYY-MM-DD HH:mm:ss").toDate();
      } else if (this.$i18n.locale === "fa") {
        if (moment(normalizedDate, "jYYYY/jMM/jDD HH:mm:ss", true).isValid()) {
          parsedDate = moment(
            normalizedDate,
            "jYYYY/jMM/jDD HH:mm:ss",
          ).toDate();
        } else if (moment(normalizedDate, "jYYYY/jMM/jDD", true).isValid()) {
          parsedDate = moment(normalizedDate, "jYYYY/jMM/jDD").toDate();
        }
      } else {
        const format =
          this.$i18n.locale === "ar"
            ? "DD/MM/YYYY HH:mm:ss"
            : "MM/DD/YYYY HH:mm:ss";
        if (moment(normalizedDate, format, true).isValid()) {
          parsedDate = moment(normalizedDate, format).toDate();
        } else if (
          moment(
            normalizedDate,
            this.$i18n.locale === "ar" ? "DD/MM/YYYY" : "MM/DD/YYYY",
            true,
          ).isValid()
        ) {
          parsedDate = moment(
            normalizedDate,
            this.$i18n.locale === "ar" ? "DD/MM/YYYY" : "MM/DD/YYYY",
          ).toDate();
        }
      }
      if (!parsedDate || isNaN(parsedDate)) {
        return moment().format("YYYY-MM-DD HH:mm:ss");
      }
      return moment(parsedDate).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    value: {
      handler(value) {
        this.$emit("input", this.convertToGregorian(value));
      },
    },
  },
};
</script>

<style scoped>
.flip-countdown {
  font-family: "Roboto", sans-serif;
}
</style>
